import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMapPin, FiPhone, FiClock } = FiIcons;

export default function StorePresence() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          <div className="relative h-[400px] overflow-hidden rounded-sm shadow-xl">
            <img 
              src="https://images.unsplash.com/photo-1578932750294-f5075e85f44a?q=80&w=1000&auto=format&fit=crop" 
              alt="Tatvam Store Interior" 
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>

          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-serif text-gray-900 mb-4">Visit Our Store</h2>
              <div className="w-16 h-1 bg-[#d4af37]"></div>
              <p className="mt-6 text-gray-600 leading-relaxed">
                Experience the luxury of premium fabrics and bespoke tailoring in person. Our expert stylists are ready to guide you.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start">
                <SafeIcon icon={FiMapPin} className="w-6 h-6 text-[#d4af37] mt-1 mr-4 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-900">Address</h4>
                  <p className="text-gray-600 mt-1">
                    9 Ganesham, Ajmer Road, Shyam Nagar No. 2<br/>
                    Behind Sodhani Sweets, Sodala, Jaipur
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <SafeIcon icon={FiPhone} className="w-6 h-6 text-[#d4af37] mt-1 mr-4 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-900">Call / WhatsApp</h4>
                  <p className="text-gray-600 mt-1">+91 91191 23305</p>
                </div>
              </div>

              <div className="flex items-start">
                <SafeIcon icon={FiClock} className="w-6 h-6 text-[#d4af37] mt-1 mr-4 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-900">Hours</h4>
                  <p className="text-gray-600 mt-1">Mon - Sun: 10:30 AM - 8:30 PM</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}